import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';

import ChemicalProductDetailsForm from './ChemicalProductDetailsForm';
import getChemicalProductDetailsFormSchema from '../../../formSchemas/ChemicalProductDetailsFormSchema';
import GenericDetails from '../../common/GenericDetails';
import { chemicalProductsHistoryActions } from '../../../behavior/chemicalProducts/history';
import { entityType, VIEW_MODE } from '../../../constants';

class ChemicalProductHistoryDetailsFormContainer extends React.Component {
  componentDidMount() {
    this.props.getInitialData(this.props.id);
    this.props.getChemicalProductHistory(this.props.id);
  }

  render() {
    const { isLoading, chemicalProduct, initialData } = this.props;
    let initialValues = chemicalProduct ? { chemicalProduct: chemicalProduct } : null;
    let cpId = initialValues ? initialValues.chemicalProduct.chemicalProductId : null;
    return (
      <GenericDetails
        initialValues={initialValues}
        validationSchema={getChemicalProductDetailsFormSchema([])}
        initialData={initialData}
        mode={VIEW_MODE}
        isLoading={isLoading}
        isHistory={true}
        id={cpId}
        entityTypeProp={entityType.productHist}
        renderContainer={props => <ChemicalProductDetailsForm {...props} isHistory={true} />}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...state.chemicalProductsHistory,
  id: ownProps.match.params.id
});

const mapDispatchToProps = dispatch => ({
  getChemicalProductHistory: id =>
    dispatch(chemicalProductsHistoryActions.getChemicalProductHistory(id)),
  getInitialData: id => dispatch(chemicalProductsHistoryActions.getInitialData(id))
});

ChemicalProductHistoryDetailsFormContainer.defaultProps = {
  initialData: {},
  chemicalProduct: null
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ChemicalProductHistoryDetailsFormContainer);
